'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

export const LanguageSwitcher: React.FC = () => {
    const { i18n } = useTranslation();

    const toggleLanguage = () => {
        const newLang = i18n.language === 'en' ? 'de' : 'en';
        i18n.changeLanguage(newLang);
        localStorage.setItem('language', newLang);
    };

    return (
        <button className="lang-switcher" onClick={toggleLanguage} aria-label="Switch language">
            <Globe size={18} />
            <span>{i18n.language.toUpperCase()}</span>
        </button>
    );
};
